import React from 'react';
import {Sx} from 'app/types/common';
import {Link, Stack, Typography} from '@mui/material';
import {LegacyIcon} from 'app/components/sharedReactComponents/LegacyIcon/LegacyIcon';
import {Icons} from 'app/util/icons';
import {pluralizeN} from 'app/components/helpers/commonHelpers';
import {router} from 'app/router/main';

interface Props extends Sx {
  premium: boolean;
  paired: number;
  total: number;
  permitModifyPlan: boolean;
}

export function SeatsSummary({sx, paired, total: seats, premium, permitModifyPlan}: Props) {
  const unlimited = seats < 0;
  const showBillingLink = permitModifyPlan && !unlimited && premium;

  return (
    <Stack sx={sx} alignItems="center" gap={1}>
      <Stack direction="row" alignItems="center" gap={1}>
        <LegacyIcon sx={{fontSize: 32}}>{Icons.devices().reactComponent()}</LegacyIcon>

        <CapacityMessage count={paired} total={seats} premium={premium} />
      </Stack>

      {showBillingLink && (
        <Typography component="span">
          Need more devices?{' '}
          <Link color="secondary" href={router.url('settingBillingUsage')}>
            Change plan
          </Link>
        </Typography>
      )}
    </Stack>
  );
}

interface MessageProps {
  count: number;
  total: number;
  premium: boolean;
}

function CapacityMessage({count, total, premium}: MessageProps) {
  let seats = '';

  if (premium) {
    if (total < 0) {
      seats = 'unlimited';
    } else {
      seats = `${total}`;
    }
  } else {
    seats = 'unlimited (limited functionality)';
  }

  return (
    <Typography>
      <strong>{count}</strong> of <strong>{seats}</strong> Edge {pluralizeN('seat', count)}{' '}
      {pluralizeN('is', count)} occupied
    </Typography>
  );
}
